import { bengaluruGps } from "./bengaluru-gps";

export const mapDefaults = {
	center: { lat: bengaluruGps.latitude, lng: bengaluruGps.longitude },
	centerGPS: { type: "Point", coordinates: [bengaluruGps.longitude, bengaluruGps.latitude] },
	zoom: 14,
	radius: 2000,
	projectZoom: 17,
	markerLimit: 100,
	/** Zoom level threshold for showing project names. Below this zoom level, names show only on hover (desktop) or tap (mobile) */
	projectNameZoomThreshold: 15,
};

/**
 * Constants for map bounds change detection
 */
export const mapBoundsConstants = {
	/**
	 * Threshold for detecting significant bounds changes (in degrees)
	 * Approximately 100 meters at the equator
	 * Used to determine when to show "Search this area" button
	 */
	BOUNDS_CHANGE_THRESHOLD_DEGREES: 0.001,
} as const;

/**
 * Special index values for location overlay selection state
 */
export const locationOverlayIndices = {
	/** Show "Search this area" button */
	SEARCH_AREA: -1,
	/** Hide overlay entirely, don't show search button */
	HIDDEN: -99,
	/** Default/first location selected */
	DEFAULT: 0,
} as const;

/**
 * Timeout durations for map interactions (in milliseconds)
 */
export const mapInteractionTimeouts = {
	/** Auto-hide duration for mobile tooltip after tap */
	MOBILE_TOOLTIP_AUTO_HIDE_MS: 3000,
	/** Debounce duration for map center/zoom change handlers */
	MAP_CHANGE_DEBOUNCE_MS: 50,
} as const;
